import React from 'react';
import {submit, isSubmitting} from 'redux-form';

import {default as Modal, withModal} from 'components/Modal';
import Button from 'components/Button';

import {MODALS} from 'ducks/teams';

import {InviteNewTeamMemberForm} from './components';

import './styles.css';

class InviteNewTeamMemberModal extends React.Component<any> {
  triggerFormSubmit = () => {
    this.props.submit('inviteNewStaffMember');
  };

  submitExtraActions = [
    ...this.props.closeModalExtraActions,
    ...this.props.data.getParrentModalExtraActions()
  ];

  render() {
    const {closeModal, data: {submitting}} = this.props;

    return (
      <Modal
        className="InviteNewTeamMemberModal"
        type={Modal.EXTRA_SMALL}
        show={true}
        onClose={closeModal}>
        <Modal.Header heading="Invite New Staff Member to Team" />
        <Modal.Body>
          <InviteNewTeamMemberForm
            submitExtraActions={this.submitExtraActions}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button white onClick={closeModal}>
            Cancel
          </Button>
          <Button
            onClick={this.triggerFormSubmit}
            blue={!submitting}
            isLoading={submitting}
            disabled={submitting}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  submitting: isSubmitting('inviteNewStaffMember')(state)
});
const mapDispatchToProps = {submit};

export default withModal(
  MODALS.INVITE_NEW_TEAM_MEMBER,
  mapStateToProps,
  mapDispatchToProps
)(InviteNewTeamMemberModal);
